import { render, staticRenderFns } from "./CGU.vue?vue&type=template&id=0bf85d16&scoped=true&"
import script from "./CGU.vue?vue&type=script&lang=js&"
export * from "./CGU.vue?vue&type=script&lang=js&"
import style0 from "./CGU.vue?vue&type=style&index=0&id=0bf85d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf85d16",
  null
  
)

export default component.exports